import { OnlineIndicator } from '@/components/online-indicator';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { useFilters } from '@/context/filters-context';
import { BadgeCheck } from 'lucide-react';

export const AvailabilityFilter = () => {
    const { filters, setFilters } = useFilters();

    const handleChange = (
        key: keyof typeof filters.availability,
        checked: boolean,
    ) => {
        setFilters((prev) => ({
            ...prev,
            availability: {
                ...prev.availability,
                [key]: checked,
            },
        }));
    };

    return (
        <div className="space-y-3">
            <div className="flex items-center space-x-2">
                <Checkbox
                    id="online-now"
                    checked={filters.availability.onlineNow}
                    onCheckedChange={(checked) =>
                        handleChange('onlineNow', checked as boolean)
                    }
                />
                <Label htmlFor="online-now" className="flex items-center gap-2">
                    <OnlineIndicator size={12} />
                    Online Now
                </Label>
            </div>

            <div className="flex items-center space-x-2">
                <Checkbox
                    id="verified"
                    checked={filters.availability.verified}
                    onCheckedChange={(checked) =>
                        handleChange('verified', checked as boolean)
                    }
                />
                <Label htmlFor="verified" className="flex items-center gap-2">
                    <BadgeCheck className="h-4 w-4 text-primary" />
                    Verified Only
                </Label>
            </div>

            <div className="flex items-center space-x-2">
                <Checkbox
                    id="new-profiles"
                    checked={filters.availability.newProfile}
                    onCheckedChange={(checked) =>
                        handleChange('newProfile', checked as boolean)
                    }
                />
                <Label
                    htmlFor="new-profiles"
                    className="flex items-center gap-2"
                >
                    <span className="h-2 w-2 rounded-full bg-green-500" />
                    New Profiles
                </Label>
            </div>
        </div>
    );
};
